<div id="contenedor">
    <div id="error">
        <h1 class="desc">Erro 404</h1>
        <h1 class="sub_desc">Página não encontrada!</h1>
    </div>
</div>



// WEBPACK FOOTER //
// /builds/sggd-10899/troca-senha-frontend/frontend/src/app/shared/components/not-found.component.html